import { fallback } from "@tanstack/zod-adapter";
import { z } from "zod";

/**
 * `?category=<ID>` — the selected course category. Shared by the courses
 * list, course page and lesson page routes so the param survives navigation
 * between them and is validated the same way everywhere.
 */
export const categorySearchSchema = z.object({
  category: fallback(z.number().optional(), undefined),
});
